<template>
  <body>
    <cursor-fx ref="cursor" color="#6b4000" color-hover="#fa9732" inside-size="15px" outside-size="90px"></cursor-fx>
    <div class="all_box"> 
      <!-- メインタイトル -->
      <div class="Home_title_box">
        <div class="Home_main_title en_font" id="title">
          <v-text>HES RECRUIT SITE</v-text>
        </div>
        <div class="Home_border" ></div>
        <div class="Home_border"></div>
        <div class="Home_main_subtitle_en en_font" id="subtitle">
          <v-text>technology supports the world</v-text>
        </div>
        <div class="Home_main_subtitle_jp jp_font" id="subtitle">
          <v-text>技術力は、世界を支える。</v-text>
        </div>
        <div class="Home_scroll_sticky en_font sample__title--hidden" :style="hiddenStyle">
          <v-text id="fixed">Please<br />scroll down<br /></v-text>
        </div>
      </div>
      <!-- メッセージ -->
      <div class="Home_message_mainbox">
        <div class="Home_message_subbox"> 
          <img class="Home_message_img Home_message_img_Animation" alt="Vue logo" v-lazy="require('@/assets/boss02_1780px.jpg')" />
          <p class="Home_message_role Home_message_name_Animation en_font">Chief Executive Officer</p>
          <p class="Home_message_name Home_message_name_Animation jp_font">Ogawa Hiroshi</p>
        
        <div class="Home_message_box en_font Home_message_box_Animation Home_message_box_Animation2" >
          
          <div class="Home_message_box2 Home_message_box_Animation3">
            <p class="Home_message_title Home_message_title_Animation">Message</p>
              <div class="Home_message_target jp_font Home_message_text_Animation">&nbsp;&nbsp;当社は[最高の技術][最高の品質][最善の努力][収益の最大化][未来志向]の5つをコアバリューと理念に掲げ、高い技術力と豊富な経験に基づいた様々なITサービスを提案しています。<br />
&nbsp;&nbsp;多様化している問題の解決には全員にスキルとリーダーシップが必要です。<br />
&nbsp;&nbsp;強い意欲と共に当社の理念に共感いただける方、一丸となって当社を盛り上げられる方を募集しています。
              </div>
          </div>
        </div>
        </div>
      </div>
      <!-- Work -->
      <div class="Home_subject en_font Home_Work_title_Animation" >
        <v-text>Career
        </v-text>
      </div>
      <div class="Home_flex-work Home_Work_img_Animation">
        <div class="item1">
          <div class="Home_Work_circle">
            <img class="Home_work_img" alt="Vue logo" v-lazy="require('@/assets/christin-hume-Hcfwew744z4-unsplash.jpg')" >
            <img class="Home_work_circle_img" alt="Vue logo" v-lazy="require('@/assets/circle.png')" >
          </div>
        </div>
        <div class="item2">
          <div class="Home_work_border Home_Work_border_Animation"></div>
          <h3 class="Home_Work_role en_font Home_Work_text_Animation">ENGINEER</h3>
            <ul class="Home_Work_career_li jp_font Home_Work_text2_Animation">
              <li data-cursor-hover ><router-link  :to="{name: 'auth/Career',hash: '#Engineer',query: { keyword: 'E-1' }}"><svg_elements name="Diagonal_line_circle" class ="home_work_career_li_svg" />
                <span class="Home_Work_career_li_contents Home_Work_text2_Animation" >クラウドサービス開発</span></router-link>
              </li>
              <li data-cursor-hover ><router-link  :to="{name: 'auth/Career',hash: '#Engineer',query: {keyword: 'E-2'}}"><svg_elements name="Diagonal_line_circle" class ="home_work_career_li_svg"/>
                <span class="Home_Work_career_li_contents Home_Work_text2_Animation">ソフトウェア設計</span></router-link>
              </li>
              <li data-cursor-hover ><router-link  :to="{name: 'auth/Career',hash: '#Engineer',query: { keyword: 'E-3' }}"><svg_elements name="Diagonal_line_circle" class ="home_work_career_li_svg"/>
                <span class="Home_Work_career_li_contents Home_Work_text2_Animation">デジタルオペレーション開発</span></router-link>
              </li>
              <li data-cursor-hover ><router-link  :to="{name: 'auth/Career',hash: '#Engineer',query: { keyword: 'E-4' }}"><svg_elements name="Diagonal_line_circle" class ="home_work_career_li_svg"/>
                <span class="Home_Work_career_li_contents Home_Work_text2_Animation">プロダクト開発</span></router-link>
              </li>
              <li data-cursor-hover ><router-link  :to="{name: 'auth/Career',hash: '#Engineer',query: { keyword: 'E-5' }}"><svg_elements name="Diagonal_line_circle" class ="home_work_career_li_svg"/>
                <span class="Home_Work_career_li_contents Home_Work_text2_Animation">ソリューションアーキテクト</span></router-link>
              </li>
            </ul>
          <h3 class="Home_Work_role_sales en_font Home_Work_text3_Animation">SALES</h3>
            <ul class="Home_Work_career_sale_li Home_Work_text4_Animation jp_font">
              <li data-cursor-hover ><router-link  :to="{name: 'auth/Career',hash: '#Sales',query: { sales_keyword: 'S-1' }}"><svg_elements name="Diagonal_line_circle" class ="home_work_career_li_svg" />
                <span class="Home_Work_career_sale_li_contents Home_Work_text4_Animation" >フロントセールス</span></router-link>
              </li>
              <li data-cursor-hover ><router-link  :to="{name: 'auth/Career',hash: '#Sales',query: { sales_keyword: 'S-2' }}"><svg_elements name="Diagonal_line_circle" class ="home_work_career_li_svg"/>
                <span class="Home_Work_career_sale_li_contents Home_Work_text4_Animation" >バックオフィス</span></router-link>
              </li>
            </ul>
            <router-link to="Career"><p class="Home_Work_view jp_font Home_Work_text4_Animation" data-cursor-hover >ViewMore</p></router-link>
          <div class="Home_work_border_sales Home_Work_border_sales_Animation"></div>
        </div>
      </div>
      
      <!-- Member Interview -->
      <div class="Home_subject en_font Home_Member_title_Animation">
        <v-text>Member Interview</v-text>
      </div>
      <div class="Home_Member_wrap">
      <!--
        <div class="Home_Member_item Home_Member_img_Animation1" data-cursor-hover ><router-link to="MemberInterview1">
          <img v-lazy="require('@/assets/member/icon_422A8495_2048px.jpg')">
          <p class="Member_Member_item_role en_font">senior engineer</p>
          <p class="Member_Member_item_text en_font">Takahiro.O</p>
          <div class="Home_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
        </div>
      -->
        <div class="Home_Member_item Home_Member_img_Animation2" data-cursor-hover ><router-link to="MemberInterview2">
          <img v-lazy="require('@/assets/member/icon_422A8652_2048px.jpg')">
          <p class="Member_Member_item_role en_font">leader engineer</p>
          <p class="Member_Member_item_text en_font">Yuta.T</p>
          <div class="Home_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
        </div>

        <div class="Home_Member_item Home_Member_img_Animation3" data-cursor-hover><router-link to="MemberInterview3">
          <img v-lazy="require('@/assets/member/icon_422A8581_2048px.jpg')">
          <p class="Member_Member_item_role en_font">general affairs</p>
          <p class="Member_Member_item_text en_font">Chiaki.O</p>
          <div class="Home_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
        </div>
      <!--
        <div class="Home_Member_item Home_Member_img_Animation4" data-cursor-hover ><router-link to="MemberInterview4">
          <img v-lazy="require('@/assets/member/icon_422A8539_2048px.jpg')">
          <p class="Member_Member_item_role en_font">engineer</p>
          <p class="Member_Member_item_text en_font">Mina.Y</p>
          <div class="Home_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
        </div>
      -->
        <div class="Home_Member_item Home_Member_img_Animation5" data-cursor-hover ><router-link to="MemberInterview5">
          <img v-lazy="require('@/assets/member/icon_422A8423_2048px.jpg')">
          <p class="Member_Member_item_role en_font">engineer</p>
          <p class="Member_Member_item_text en_font">Tomohiro.M</p>
          <div class="Home_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
        </div>
      </div>
      
      <!-- About -->
      <div class="Home_subject en_font Home_About_title_Animation">
        <v-text>About</v-text>
      </div>
      <div class="Home_About_flex-work">
        <div class="item1 Home_About_img_Animation">
          <img class="Home_About_img hvr-wobble-horizontal" alt="Vue logo" v-lazy="require('@/assets/sean-pollock-PhYq704ffdA-unsplash.jpg')" >
        </div>
        <div class="item2 ">
          <h3 class="Home_About_text jp_font Home_About_text_Animation">事業概要</h3>
            <div class="Home_About_overflow-wrap Home_About_text2_Animation">
              <p>&nbsp;&nbsp;&nbsp;&nbsp;顧客の要求や課題を解決するため、
                 システムの要件定義から
                 構築・テストまでを実施しています。<br />
                 &nbsp;&nbsp;&nbsp;&nbsp;ITコンサルティングやクラウドサービス設計
                 構築、SaaS、DXなどを主軸とした
                 ITエンジニアリング事業を
                 幅広く行っています。
              </p>
            </div>
            <a href="https://www.he-service.co.jp/bis.html" target="_blank" rel="noopener noreferrer"><p class="Home_About_view jp_font Home_About_text3_Animation" data-cursor-hover >ViewMore</p></a>
        </div>
      </div>
      <!-- Welfare -->
      <div class="Home_subject en_font Home_Welfare_title_Animation" >
        <v-text>Welfare</v-text>
      </div>
      <div class="Home_About_flex-work " >
        <div class="item1 Home_Welfare_img_Animation">
          <a href="#"><span class="mask"><img class="Home_Welfare_img bordercircle3" alt="Vue logo" v-lazy="require('@/assets/alesia-kazantceva-VWcPlbHglYc-unsplash.jpg')" ></span></a>
        </div>
        <div class="item2">
            <ul class="Home_Welfare_li jp_font">
              <router-link  :to="{name: 'auth/Welfare',hash: '#HumanResources'}"><li class="Home_Welfare_text_Animation" data-cursor-hover>人材育成制度<v-icon class="Home_Welfare_li_icon" color="white">mdi-arrow-right</v-icon></li></router-link>
              <router-link  :to="{name: 'auth/Welfare',hash: '#Subsidy'}"><li class="Home_Welfare_text2_Animation" data-cursor-hover>ベネフィット<v-icon class="Home_Welfare_li_icon" color="white">mdi-arrow-right</v-icon></li></router-link>
              <router-link  :to="{name: 'auth/Welfare',hash: '#DayOff'}"><li class="Home_Welfare_text3_Animation" data-cursor-hover>多様な働き方<v-icon class="Home_Welfare_li_icon" color="white">mdi-arrow-right</v-icon></li></router-link>
            </ul>
            <router-link to="Welfare"><p class="Home_Welfare_view jp_font Home_Welfare_text4_Animation" data-cursor-hover>ViewMore</p></router-link>
        </div>
      </div>
      <!-- Application Requirements -->
      <div class="Home_subject en_font Home_Application_title_Animation" >
        <v-text>Recruitment type</v-text>
      </div>
      <v-container class="Home_Application Home_Application_img_Animation" >
        <v-row justify="space-around">
          <v-col cols="12" sm="6" md="4" lg="3" align="center" class="Home_Application_item1_Animation">
            <p class="Home_Application_text">
              株式会社HESでは、<br />
              共に未来を創れる仲間を募集中です。<br />
              まずは、募集要項をご覧ください。
            </p>
            <router-link to="ApplicationType" class="Home_circle" data-cursor-hover><p class="Home_circle_view">View Jobs</p></router-link>
          </v-col>
          <v-divider vertical class="Home_Application_border_Animation"></v-divider>
          <v-col cols="12" sm="6" md="4" lg="3" align="center" class="Home_Application_item2_Animation">
            <p class="Home_Application_text">
              本サイトを見て興味を持った方、<br />
              もっと詳しく話が聞きたいという方は<br />
              お気軽にお問い合わせください。
            </p>
            <a href="https://www.he-service.co.jp/ctt.html" target="_blank" rel="noopener noreferrer" class="Home_circle" data-cursor-hover ><p class="Home_circle_view">Contact Us</p></a>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </body>
</template>

<script>
import svg_elements from "@/assets/svg_elements";
import { gsap } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'Home',
  components: {
    svg_elements,
  },
  data() {
    return {
      targetRect: 0,
      hiddenStyle: {}
    };
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // スクロール非表示用
    handleScroll() {
      const title = document.querySelector(`.sample__title--hidden`);
      const rect = title.getBoundingClientRect().top;
      this.targetRect = rect;
      if (this.targetRect < 300) {
        this.$set(this.hiddenStyle, 'visibility', 'hidden');
      } else {
        this.$set(this.hiddenStyle, 'visibility', 'visible');
      }
    },
    startMaintitle() {
      // タイトル
      gsap.fromTo('#title', {
          opacity: 0,
          y: 0,
        },
        {
          opacity: 1,
          y: 0,
          duration: 3,
          delay: 1.5,
        }
      ),
      gsap.fromTo('#subtitle', {
          opacity: 0,
          y: 30,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: 3,
        }
      ),
      // メッセージ
      gsap.fromTo('.Home_message_box_Animation', 
        {
          y: 30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_message_box_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.to(
        ".Home_message_box_Animation2",
        {
          rotation: 3,
          duration: 3,
          repeat: -1,
          yoyo: true
        },
      ),
      gsap.to(
        ".Home_message_box_Animation3",
        {
          rotation: -3,
          duration: 3,
          repeat: -1,
          yoyo: true
        },
      ),
      gsap.fromTo('.Home_message_img_Animation', 
        {
          y: 30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_message_img",
          },
          y: 0,
          x: 0,
          duration: 1,
          delay: 0.5,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_message_title_Animation', 
        {
          y: 30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_message_title_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          delay: 1,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_message_text_Animation', 
        {
          y: 30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_message_target",
          },
          y: 0,
          x: 0,
          duration: 1,
          delay: 1.5,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_message_name_Animation', 
        {
          x: -100,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_message_name",
          },
          y: 0,
          x: 0,
          duration: 1,
          delay: 1,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      // キャリア
      gsap.fromTo('.Home_Work_title_Animation', 
        {
          y: 30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Work_title_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Work_img_Animation', 
        {
          y: 30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Work_img_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          delay: 0.3,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Work_border_Animation', 
        {
          x: -50,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Work_border_Animation",
          },
          y: 0,
          x: 0,
          delay: 0.6,
          duration: 1,
          ease:"Linear.easeNone",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Work_text_Animation', 
        {
          x: -50,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Work_border_Animation",
          },
          y: 0,
          x: 0,
          delay: 1,
          duration: 1,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Work_text2_Animation', 
        {
          x: -50,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Work_border_Animation",
          },
          y: 0,
          x: 0,
          delay: 1.5,
          duration: 1,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Work_text3_Animation', 
        {
          x: -50,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Work_border_Animation",
          },
          y: 0,
          x: 0,
          delay: 2,
          duration: 1,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Work_text4_Animation', 
        {
          x: -50,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Work_border_Animation",
          },
          y: 0,
          x: 0,
          delay: 2.5,
          duration: 1,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Work_border_sales_Animation', 
        {
          x: -50,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Work_border_Animation",
          },
          y: 0,
          x: 0,
          delay: 3.5,
          duration: 1,
          ease:"Linear.easeNone",
          opacity: 1,
        }
      ),
      // メンバーインタビュー
      gsap.fromTo('.Home_Member_title_Animation', 
        {
          y: 30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Member_title_Animation",
          },
          y: 0,
          x: 0,
          duration: 1.5,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Member_img_Animation1', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1,
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Member_img_Animation2', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1.3,
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Member_img_Animation3', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1.6,
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Member_img_Animation4', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1.9,
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Member_img_Animation5', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 2.1,
          opacity: 1,
        }
      ),
      // アバウト
      gsap.fromTo('.Home_About_title_Animation', 
        {
          y: 30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_About_title_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_About_img_Animation', 
        {
          y: 30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_About_img_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          delay: 0.5,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_About_text_Animation', 
        {
          x: -50,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_About_text_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          delay: 1,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_About_text2_Animation', 
        {
          x: -50,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_About_text_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          delay: 1.5,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_About_text3_Animation', 
        {
          x: -50,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_About_text_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          delay: 2,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      // 福利厚生
      gsap.fromTo('.Home_Welfare_title_Animation', 
        {
          y: 30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Welfare_title_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Welfare_img_Animation', 
        {
          y: 30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Welfare_img_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          delay: 0.5,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Welfare_text_Animation', 
        {
          x: -30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Welfare_text_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          delay: 1,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Welfare_text2_Animation', 
        {
          x: -30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Welfare_text_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          delay: 1.3,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Welfare_text3_Animation', 
        {
          x: -30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Welfare_text_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          delay: 1.6,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Welfare_text4_Animation', 
        {
          x: -30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Welfare_text_Animation",
          },
          y: 0,
          x: 0,
          duration: 0.5,
          delay: 2,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      // 募集要項
      gsap.fromTo('.Home_Application_title_Animation', 
        {
          y: 30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Application_title_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Application_item1_Animation', 
        {
          y: 30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Application_title_Animation",
          },
          y: 0,
          x: 0,
          duration: 1,
          delay: 0.5,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Application_item2_Animation', 
        {
          y: 30,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Application_title_Animation",
          },
          y: 0,
          x: 0,
          delay: 1,
          duration: 1,
          ease:"power2.easeInOut",
          opacity: 1,
        }
      ),
      gsap.fromTo('.Home_Application_border_Animation', 
        {
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Home_Application_title_Animation",
          },
          y: 0,
          x: 0,
          delay: 1,
          duration: 1.5,
          ease:"Linear.easeNone",
          opacity: 1,
        }
      )
    }
  },
  mounted() {
    this.startMaintitle()
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss">
@import "../css/Portal_base.css";

/* レスポンシブ */
@media screen and (max-width: 480px) {
    html {
        font-size: 35% !important;
    }
    .Home_border {
        width: 8% !important;
    }
    .Home_main_title {
        text-shadow: 0px 2px 1px #6b4000 !important;   
    }
    .Home_message_mainbox{
        width:80% !important;
        height: 650px !important;
        margin-bottom: 70px !important;
    }
    .Home_message_box{
        width: 100% !important;
        top: 350px !important;
        height: 290px !important;
        font-size: 24px !important;
        padding: 5% 5% !important;
    }
    .Home_message_target {
        top: 10% !important;
        font-size: 11px !important;
    }
    .Home_message_img{
        width: 100% !important;
        object-position: 0% 100% !important;
        object-fit: cover !important;
        top: 20px !important;
        height: 280px !important;
    }
    .Home_message_role{
        left: 10px !important;
        top: 245px !important;
        font-size: 9px !important;
    }
    .Home_message_name{
        top: 260px !important;
        left: 25px !important;
        font-size: 20px !important;
    }
    .Home_Member_item {
      width:250px !important;
      margin: 0 auto !important;
    }
    .Home_Member_item_text {
        bottom: -9px !important;
    }
    .Home_flex-work {
        max-width: 100% !important;
        margin: 0 auto 80px auto !important;
    }
    .Home_flex-work .item2 {
        flex: 0 280px !important;
        height: 300px !important;
    }
    .Home_work_img{
        width:280px !important;
    }
    .Home_work_circle_img{
        width: 310px !important;
        bottom: 50px !important;
        left: -110px !important;
    }
    .Home_Work_role{
        top: 10px  !important;
        left: 10px !important;
        font-size: 20px !important;
    }
    .Home_Work_career_li {
        top: 40px !important;
        left: 0px !important;
        width: 270px !important;
    }
    .Home_Work_career_li_contents {
        font-size: 13px !important;
        margin-top: 5px !important;
        width: 200px !important;
    }
    .Home_Work_career_li li {
        height: 1.5em !important;
        
    }
    .home_work_career_li_svg {
        height: 1.5em !important;
    }
    .Home_Work_career_sale_li {
        top: 210px !important;
        left: 0px !important;
        width: 270px !important;
    }
    .Home_Work_career_sale_li li {
        height: 1.5em !important;
    }
    .Home_Work_career_sale_li_contents {
        font-size: 13px !important;
        margin-top: 5px !important;
        width: 250px !important;
    }

    .Home_Work_role_sales{
        top: 180px  !important;
        left: 10px !important;
        font-size: 20px !important;
    }
    .Home_Work_view {
        bottom: 13px !important;
        font-size: 12px !important;
        right: 20px !important;
    }
    .Home_Work_view::after {
        width: 70px !important;
        right: -4px !important;
        height: 7px !important;
    }
    .Home_work_border {
        width:280px !important;
        left: 0px !important;
    }
    .Home_work_border_sales {
        width:280px !important;
        bottom: 23px !important;
        left: 0px !important;
    }
    .Home_Member_wrap {
        margin: 0 auto 70px auto !important;
    }
    .Home_About_flex-work {
        margin-bottom: 72px !important;
    }
    .Home_About_flex-work .item2 {
        flex: 0 250px !important;
    }
    .Home_About_img{
        width:250px !important;
        margin-bottom: 10px !important;
    }
    .Home_About_text {
        margin-left: 1px !important;
        font-size: 13px !important;
    }
    .Home_About_text:after {
        width: 170px  !important;
    }
    .Home_About_overflow-wrap{
        width: 220px !important;
        margin-top: 10px !important;
        margin-left: 15px !important;
        font-size: 11px !important;
    }
    .Home_About_view {
        position: absolute !important;
        font-size: 10px !important;
        right: 14px !important;
        bottom: -20px !important;
    }
    .Home_About_view::after {
        width: 60px !important;
        right: -2px !important;
        height: 7px !important;
    }
    .Home_Welfare_img{
        width:250px !important;
        margin-bottom: 10px !important;
    }
    ul.Home_Welfare_li li{
        height: 30px !important;
        font-size: 12px !important;
        margin-bottom: 10px !important;
        margin-left: -25px !important;
        padding: 7px 20px !important;
    }
    .Home_Welfare_view {
        position: absolute !important;
        font-size: 10px !important;
        right: 14px !important;
        bottom: -30px !important;
    }
    .Home_Welfare_view::after {
        width: 60px !important;
        right: -2px !important;
        height: 7px !important;
    }
    .Home_Welfare_li_icon {
        font-size: 17px !important;
    }
    .Home_Application_text {
        font-size: 11px !important;
    }
    .Home_circle {
        width: 100px !important;
        height: 100px !important;
    }
    .Home_circle_view {
        font-size: 10px !important;
    }
    .Home_circle_view::after {
        width: 60px !important;
        right: -4px !important;
        bottom: -3px !important;
        height: 6px !important;
    }
    .Home_Application_border_Animation {
      display: none !important;
    }
}
@media screen and (min-width: 481px) and (max-width: 960px) {
    html {
        font-size: 50% !important;
    }
    .Home_border {
        width: 8% !important;
    }
    .Home_message_mainbox{
        width:80% !important;
        margin-bottom: 250px !important;
        height: 580px !important;
    }
    .Home_message_box{
        width: 100% !important;
        top: 380px !important;
        height: 320px !important;
        font-size: 28px !important;
        padding: 5% 5% !important;
    }
    .Home_message_target {
        top: 10% !important;
        font-size: 12.5px !important;
    }
    .Home_message_img{
        width: 100% !important;
        object-position: 0% 30% !important;
        object-fit: cover !important;
        top: 20px !important;
        height: 320px !important;
    }
    .Home_message_role{
        left: 32px !important;
        top: 275px !important;
        font-size: 10px !important;
    }
    .Home_message_name{
        top: 290px !important;
        left: 25px !important;
        font-size: 25px !important;
    }
    .Home_flex-work {
        max-width: 100% !important;
        flex-flow: column !important;
        margin: 0 auto  !important;
    }
    .Home_work_img{
        width:60% !important;
        margin-left: 20% !important;
    }
    .Home_work_circle_img{
        width:60% !important;
        left: 15px !important;
        bottom: 70px !important;
    }
    .Home_Work_role{
        top: 20px !important;
        left: 24% !important;
        font-size: 20px !important;
    }
    .Home_Work_career_li li {
        height: 1.6em !important;
    }
    .home_work_career_li_svg {
        width: 1em !important;
        height: 1.5em !important;
        margin: 0;
        padding: 0;
    }
    .Home_Work_career_li {
        top: 50px !important;
        left: 25% !important;
    }
    .Home_Work_career_li_contents {
        font-size: 13px !important;
        margin-top: 5px !important;
        width: 200px !important;
    }
    .Home_Work_role_sales{
        top: 200px !important;
        left: 24% !important;
        font-size: 20px !important;
    }
    .Home_Work_career_sale_li li {
        height: 1.6em !important;
    }
    .Home_Work_career_sale_li {
        top: 230px !important;
        left: 25% !important;
    }
    .Home_Work_career_sale_li_contents {
        font-size: 13px !important;
        margin-top: 5px !important;
    }
    .Home_Work_view {
        right: 24% !important;
        bottom: 90px !important;
        font-size: 12px !important;
    }
    .Home_work_border {
        width:60% !important;
        left: 20% !important;
        margin-top: 14px !important;
    }
    .Home_work_border_sales {
        width:60% !important;
        left: 20% !important;
        bottom: 95px !important;
    }
    .Home_Member_wrap {
        margin: 0 auto 120px auto !important;
    }
    .Home_Member_item {
        width: calc((100% - 30px) / 2) !important;
    }
    .Home_Member_item_text {
        font-size: 3vw !important;
        bottom: -9px !important;
    }
    .Home_Member_item_text2 .view_more {
        font-size: 3vw !important;
    }
    .Home_About_view {
        position: absolute !important;
        right: 14px !important;
        bottom: -10px !important;
    }
    .Home_About_flex-work {
        flex-flow: column !important;
        margin-bottom: 70px !important;
    }
    .Home_About_flex-work .item2 {
        flex: 0 210px !important;
        width: 60% !important;
        margin-left: 20% !important;
    }
    .Home_About_img{
        width:60% !important;
        margin-left: 20% !important;
        margin-bottom: 10px !important;
    }
    .Home_About_text {
        margin-left: 0px !important;
        font-size: 3vw !important;
    }
    .Home_About_text:after {
        width:70% !important;
        position: absolute !important;
        right: 0 !important;
    }
    .Home_About_overflow-wrap{
        width:80% !important;
        margin: 10px  auto !important;
        font-size: 13px !important;
    }
    .Home_About_view {
        position: absolute !important;
        bottom: 2% !important;
    }
    .Home_Welfare_img{
        width:60% !important;
        margin-left: 20% !important;
        margin-bottom: 20px !important;
    }
    ul.Home_Welfare_li {
      padding: 0px !important;
    }
    ul.Home_Welfare_li li{
        width:100% !important;
        margin-left: 0 !important;
        height: 60px !important;
        font-size: 16px !important;
        margin-bottom: 20px !important;
        padding: 18px 20px !important;
    }
    .Home_Welfare_view {
        position: absolute !important;
        right: 15px !important;
        bottom: -30px !important;
    }
    .Home_Application_title_Animation {
        margin-top: 110px !important;
    }
    .Home_Application_text {
        font-size: 13px !important;
    }
    .Home_circle_view {
        font-size: 13px !important;
    }
    .Home_circle_view::after {
        width: 69px !important;
        right: -3px !important;
        bottom: -3px !important;
    }
}
@media screen and (min-width: 961px) and (max-width: 1200px) {
    html {
        font-size: 62.5% !important;
    }
    .Home_message_mainbox{
        height: 600px !important;
        width:900px !important;
        margin-bottom: 150px !important;
    }
    .Home_message_box{
        width: 650px !important;
        height: 350px !important;
        top: 190px !important;
        font-size: 33px !important;
    }
    .Home_message_target {
        font-size: 16px !important;
    }
    .Home_message_img{
        width: 800px !important;
        height: 340px !important;
        object-position: 0%  36% !important;
    }
    .Home_message_role{
        left: 10px !important;
        top: 520px !important;
        font-size: 10px !important;
    }
    .Home_message_name{
        color: #fa9732;
        position: absolute;
        left: 16px !important;
        top: 530px !important;
        font-size: 22px !important;
        letter-spacing : 4px;
    }
    .Home_flex-work {
        max-width: 100% !important;
        flex-flow: column !important;
        margin-bottom: 200px !important;
    }
    .Home_work_img{
        width:60% !important;
        margin-left: 20% !important;
    }
    .Home_work_circle_img{
        width:60% !important;
        left: 30px !important;
        bottom: 120px !important;
    }
    .Home_Work_role{
        top: 30px !important;
        left: 23% !important;
    }
    .Home_Work_career_li {
        top: 70px !important;
        left: 25% !important;
    }
    .Home_Work_role_sales{
        top: 300px !important;
        left: 23% !important;
        font-size: 26px !important;
    }
    .Home_Work_career_sale_li {
        top: 335px !important;
        left: 25% !important;
    }
    .Home_Work_view {
        right: 24% !important;
        bottom: -40px !important;
        font-size: 12px !important;
    }
    .Home_work_border {
        width:60% !important;
        left: 20% !important;
        margin-top: 14px !important;
    }
    .Home_work_border_sales {
        width:60% !important;
        left: 20% !important;
        bottom: -40px !important;
    }
    .Home_Member_wrap {
        margin: 0 auto 150px auto !important;
    }
    .Home_Member_item_text {
        bottom: -9px !important;
    }
    .Home_About_flex-work {
        margin-bottom: 210px !important;
    }
    .Home_About_flex-work .item2 {
        flex: 0 310px !important;
    }
    .Home_About_img{
        width:560px !important;
    }
    .Home_About_text {
        margin-left: 10px !important;
        font-size: 22px !important;
    }
    .Home_About_text:after {
        width: 50%  !important;
    }
    .Home_About_overflow-wrap{
        width: 260px !important;
        margin-left: 30px !important;
        margin-top: 30px !important;
        font-size: 13px !important;
    }
    .Home_About_view {
        position: absolute !important;
        right: 14px !important;
        bottom: 15px !important;
    }
    .Home_About_text:after {
        width: 182px !important;
    }
    .Home_Welfare_img{
        width:560px !important;
    }
    ul.Home_Welfare_li li{
        height: 50px !important;
        font-size: 17px !important;
        margin-bottom: 25px !important;
        padding: 12px 20px !important;
    }
    .Home_Welfare_view {
        bottom: -8px !important;
    }
    .Home_circle_view {
        font-size: 13px !important;
    }
    .Home_circle_view::after {
        width: 69px !important;
        right: -3px !important;
        bottom: -3px !important;
    }
    .Home_Application_text {
        font-size: 13px !important;
    }
}
@media screen and (min-width: 1201px) and (max-width: 1500px)  {
	html {
        font-size: 62.5% !important;
    }
    .Home_message_mainbox{
        height: 700px !important;
        width:1100px !important;
        margin-bottom: 200px !important;
    }
    .Home_message_box{
        width: 800px !important;
        height: 380px !important;
        font-size: 36px !important;
    }
    .Home_message_target {
        font-size: 18px !important;
    }
    .Home_message_img{
        width: 950px !important;
        height: 390px !important;
        object-position: 0%  38% !important;
    }
    .Home_message_role{
        left: 30px !important;
        top: 570px !important;
        font-size: 12px !important;
    }
    .Home_message_name{
        left: 28px !important;
        top: 580px !important;
        font-size: 28px !important;
    }
    .Home_flex-work {
        max-width: 100% !important;
        margin-bottom: 220px !important;
    }
    .Home_work_img{
        height:480px !important;
        width: 750px !important;
    }
    .Home_work_circle_img{
        width: 670px !important;
        left: -180px !important;
        bottom: 110px !important;
    }
    .Home_Work_role{
        top: 20px !important;
        left: 11% !important;
    }
    .Home_Work_career_li {
        top: 60px !important;
        left: 12% !important;
        font-size: 24px !important;
    }
    .Home_Work_role_sales{
        top: 300px !important;
        left: 11% !important;
    }
    .Home_Work_career_sale_li {
        top: 350px !important;
        left: 12% !important;
        font-size: 24px !important;
    }
    .Home_Work_view {
        right: 12px !important;
    }
    .Home_work_border {
        left: 20px !important;
    }
    .Home_work_border_sales {
        left: 20px !important;
        margin-top: 10px !important;
    }
    .Home_Member_wrap {
        margin: 0 auto 200px auto !important;
    }
    .Home_About_flex-work{
        margin-bottom: 200px !important;
    }
    .Home_About_flex-work .item2 {
        flex: 0 300px !important;
    }
    .Home_About_overflow-wrap{
        width: 255px !important;
        margin-left: 37px !important;
        font-size: 15px !important;
    }
    .Home_About_text {
        margin-left: 18px !important;
        font-size: 20px !important;
    }
    .Home_About_text:after {
        width: 170px !important;
    }
    .Home_About_view {
        bottom: 110px !important;
    }
    .Home_circle_view {
        font-size: 14px !important;
    }
    .Home_Application_text {
        font-size: 15px !important;
    }
}

@media (hover: hover) and (pointer: fine) {
  .Home_Member_item:hover img{
    filter: grayscale(100%);
    transition-duration: 0.5s;
  }
  .Home_Member_item:hover .Home_Member_item_text2{
    transition-duration: .4s;
    opacity: 1;
  }
  .Home_Work_view:hover{
      color: #6b4000;
  }
  .Home_Work_view:hover::after {
    transform: scale(1, 1) skew(45deg);
  }
  .Home_About_view:hover{
      color: #6b4000;
  }
  .Home_About_view:hover::after {
    transform: scale(1, 1) skew(45deg);
  }
  .Home_Work_career_li_contents:hover {
    color:  #6b4000;
    letter-spacing: 2.5px;
    transition: all .5s;
  }
  .Home_Work_career_sale_li_contents:hover {
    color:  #6b4000;
    letter-spacing: 2.5px;
    transition: all .5s;
  }
  ul.Home_Welfare_li li:hover::before{
      height: 100%;
  }
  ul.Home_Welfare_li li:hover .Home_Welfare_li_icon{
      margin-right: -8px;
  }
  .Home_Welfare_view:hover{
      color: #6b4000;
  }
  .Home_Welfare_view:hover::after {
    transform: scale(1, 1) skew(45deg);
  }
  .Home_circle:hover::before{
      height: 100%;
  }
  .Home_circle:hover .Home_circle_view::after{
      transform: scale(1, 1) skew(45deg);
  }
}


/*Home*/
.Home_title_box {
    height: 100vh;
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    position: relative;
}

.Home_main_title {
    color: #c04d00;
    font-size: 10rem;
    word-spacing:10px;
    margin-bottom: 3%;
    margin-left: 5%;
    margin-right: 5%;
    text-align: center;
    letter-spacing : 4px;
    text-shadow: 0 0.6rem 0 #6b4000;
    line-height: 9rem;
}

.Home_border {
    border:none;
    height:3px;
    position: relative;
    width: 100px;
    margin-top:0.5%;
    
}

.Home_border:before{
	content: '';
	position: absolute;
	left: 0;
	bottom: 0;
	border-bottom: solid 3px #c04d00;
    animation-delay: 2s;
	animation-name: Home_border_anim;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-duration:1s;
}

@keyframes Home_border_anim {
	0%{
		width: 0%;
	}
	100%{
		width: 100%;
	}
}

.Home_main_subtitle_en {
    color: #fa9732;
    font-size: 3rem;
    word-spacing:8px;
    margin-top: 3%;
    text-align: center;
    letter-spacing : 4px;
}

.Home_main_subtitle_jp {
    color: #fa9732;
    font-size: 3rem;
    word-spacing:8px;
    margin-top: 1%;
    text-align: center;
    letter-spacing : 4px;
}


.Home_scroll_sticky {
    color: #c04d00;
    font-size: 1.5rem;
    position: absolute;
    bottom: 5%;
    text-align: center;
    letter-spacing : 4px;
    animation-name: Home_scroll_flash;
    animation-fill-mode:backwards;
    animation-duration:3s;
    animation-iteration-count:infinite;
    animation-timing-function:ease;
    animation-delay: 3.5s;
    animation-direction:normal;
}

@keyframes Home_scroll_flash {
    0%,100% {
        opacity: 0;
      }
    
      50% {
        opacity: 1;
      }
}
  
.Home_message_mainbox{
    height: 800px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
}
.Home_message_mainbox{
    width:1400px;
    position: relative;
    margin: 0 auto 230px auto;
}
.Home_message_box{
    width: 1000px;
    height: 39rem;
    padding: 2% 4%;
    transform: rotate(2deg);
    background-color: #fa9732;
    z-index: 2;
    color: white;
    font-size: 40px;
    letter-spacing : 4px;
    position: absolute;
    right: 0;
    top: 200px;
}

.Home_message_box2{
    content: "";
    display: block;
    background: #c04d00;
    position: absolute;
    transform: rotate(-2deg);
    left: 1%;
    right: 0%;
    top: 0;
    bottom: 0;
    margin: 0;
    z-index: -1;
}

.Home_message_title {
    position: absolute;
    left: 5%;
    right: 0%;
    top: 2%;
}

.Home_message_target {
    content: "";
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 10%;
    right: 0%;
    top: 6%;
    bottom: 0;
    margin: 0;
    z-index: -1;
    font-size: 21px;
    width: 80%
}

.Home_message_img{
    width: 1200px;
    height: 500px;  /* 高さは自動指定 */
    display: block;
    position: absolute;
    left: 0;
    top: 240px;
    object-fit: cover;
    object-position: 0%  30%;
}

.Home_message_role{
    color: #fa9732;
    position: absolute;
    left: 38px;
    top: 640px;
    font-size: 18px;
    letter-spacing : 4px;
}

.Home_message_name{
    color: #fa9732;
    position: absolute;
    left: 40px;
    top: 660px;
    font-size: 38px;
    letter-spacing : 4px;
}

.Home_subject {
    color: #c04d00;
    font-size: 6rem;
    margin-top: 5%;
    margin-bottom: 3%;
    margin-left:5%;
    margin-right:5%;
    text-align: center;
    letter-spacing : 4px;
    z-index: 30;
}

.Home_Work_role{
    color: #c04d00;
    position: absolute;
    top: 30px;
    left: 75px;
    font-size: 29px;
    letter-spacing : 4px;
}
.Home_Work_career_li {
    list-style: none;
    color: #c04d00;
    position: absolute;
    top: 80px;
    left: 75px;
    font-size: 27px;
    letter-spacing : 2px;
    vertical-align: middle;
}
.Home_Work_career_li li {
    height: 2.5em;
    font-size: 18px;
    -webkit-box-align: center;
    position: relative;
}
.home_work_career_li_svg {
    width: 1.5em;
    height: 2.5em;
    position: absolute;
    left: -20px;
    top: 3px;
}
.Home_Work_career_li_contents {
    margin-left: 10px;
    margin-top: 10px;
    position: absolute;
    width:300px;
    color: #c04d00;
    transition: all .5s;
}


.Home_Work_role_sales{
    color: #c04d00;
    position: absolute;
    top: 350px;
    left: 75px;
    font-size: 29px;
    letter-spacing : 4px;
}
.Home_Work_career_sale_li {
    list-style: none;
    color: #c04d00;
    position: absolute;
    top: 400px;
    left: 75px;
    font-size: 27px;
    letter-spacing : 2px;
}
.Home_Work_career_sale_li li {
    height: 2.5em;
    font-size: 18px;
    position: relative;
}
.Home_Work_career_sale_li_contents {
    margin-left: 10px;
    margin-top: 10px;
    position: absolute;
    width:300px;
    color: #c04d00;
}





.Home_Work_view {
    color: #fa9732;
    position: absolute ;
    right: -15px ;
    bottom: 5px ;
    font-size: 15px;
}
.Home_Work_view::after {
    content: "";
    position: absolute;
    width: 80px;
    height: 9px;
    bottom: -1px;
    right: -3px;
    border-bottom: 1px solid #6b4000;
    border-right: 0.1px solid #6b4000;
    transform: scale(0, 1);
    transform-origin: left top;
    transition: transform .3s;
}



.Home_Work_circle{
    position: relative;
    overflow: hidden;
}

.Home_work_img{
    width: 825px;
    right: 0;
    height: auto;
    object-fit: cover;
}

.Home_work_circle_img{
    position: absolute;
    width: 750px;
    bottom: 120px;
    left: -190px;
    z-index: 1;
    animation: rotate-anime 60s linear infinite;
}
@keyframes rotate-anime {
    0%  {transform: rotate(0);}
    100%  {transform: rotate(360deg);}
  }

.Home_flex-work {
    display: flex;
    max-width: 1400px;
    margin: 0 auto 250px auto;
    flex-wrap: wrap;
    justify-content: center;
}
.Home_flex-work .item1 {
    flex: 0 0 50%;
}
.Home_flex-work .item2 {
    flex: 0 400px;
    position: relative;
}

.Home_work_border {
    border:none;
    height:3px;
    position: absolute ;
    left: 50px ;
    top: 0px ;
    background-color:#c04d00;
    width: 380px;
}

.Home_work_border_sales {
    border:none;
    height:3px;
    position: absolute ;
    left: 50px ;
    bottom: 5px ;
    background-color:#c04d00;
    width: 380px;
}

/* Member Interview */
.Home_Member_wrap {
  display: flex;
  flex-wrap: wrap;
  width: 80%;
  max-width: 1200px;
  margin: 0 auto 230px auto;
  gap: 30px;
}

.Home_Member_item {
  width: calc((100% - 30px * 2) / 3);
  overflow: hidden;
  position: relative;
}

.Home_Member_item_text {
  color: #fa9732;
  position: absolute;
  font-size: 20px;
  left: 10px;
  bottom: 0;
}
.Home_Member_item .Home_Member_item_text2 {
  color: #fa9732;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  color: #fff;
  background-color: rgba(0,0,0,0.65);
  opacity: 0;
  transition: .4s ease-in-out;
}
.Home_Member_item_text2 .view_more {
    font-size: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
}

.Home_Member_item img {
  object-fit: cover;
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  transform: scale(1.1);
  filter: grayscale(0);
  transition-duration: 0.5s;
}

.Member_Member_item_role{
    color: #c04d00;
    position: absolute;
    font-size: 10px;
    left: 18px;
    bottom: 15px;
}
.Member_Member_item_text {
    color: #fa9732;
    position: absolute;
    font-size: 20px;
    left: 18px;
    bottom: -10px;
    text-shadow: 0 0.1rem 0 #6b4000; 
}


// About
.Home_About_flex-work {
    display: flex;
    max-width: 1400px;
    margin: 0 auto 230px auto;
    flex-wrap: wrap;
    justify-content: center;
}
.Home_About_flex-work .item1 {
    flex: 0 0 50%;
}
.Home_About_flex-work .item2 {
    flex: 0 400px;
    position: relative;
}

.Home_About_img{
    max-width: 850px;
    height: auto;
    -webkit-clip-path: polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%);
		clip-path: polygon(33% 0, 100% 0, 100% 20%, 100% 71%, 65% 100%, 0 100%, 0% 80%, 0 32%);
}

.Home_About_text {
    display: flex;
    font-size: 1.7rem;
    align-items: center;
    color: #c04d00;
    margin-left: 50px;
    letter-spacing : 4px;
}

.Home_About_text:after {
    border-top: 1px solid;
    content: "";
    width: 240px;
    border-width: 3px;
    color: #c04d00;
}

.Home_About_text:after {
    margin-left: 1rem;
}

.Home_About_overflow-wrap{
    display: flex;
    font-size: 16px;
    color: #c04d00;
    width: 290px;
    margin-top: 30px;
    margin-left: 70px;
    overflow-wrap:  break-word;
}


.Home_About_view {
    color: #fa9732;
    position: absolute ;
    right: 20px ;
    bottom: 100px ;
    font-size: 15px;
}

.Home_About_view::after {
    content: "";
    position: absolute;
    width: 80px;
    height: 10px;
    bottom: -1px;
    right: -10px;
    border-bottom: 1px solid #6b4000;
    border-right: 0.1px solid #6b4000;
    transform: scale(0, 1);
    transform-origin: left top;
    transition: transform .3s;
}



// Welfare
.Home_Welfare_img{
    width: 850px;
    height: auto;
    object-fit: cover;
    -webkit-clip-path: polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%);
		clip-path: polygon(39% 0, 80% 0%, 100% 0, 100% 100%, 80% 100%, 70% 100%, 0% 80%, 0% 20%);
    transition: all .3s;
    transition-delay: .7s;/*0.7秒遅れてアニメーション*/
}







ul.Home_Welfare_li{
    list-style-type: none;
    letter-spacing : 4px;
}
ul.Home_Welfare_li li{
    background-color: #c04d00;
    color: #fff;
    display: block;
    height: 80px;
    font-size: 18px;
    margin-bottom: 30px;
    padding: 30px 20px;
    position: relative;
    z-index: 0;
    overflow: hidden;
}
ul.Home_Welfare_li li::before {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 0%;
    background-color: #6b4000;
    -webkit-transition: .2s;
    transition: .2s;
}


.Home_Welfare_view {
    color: #fa9732;
    position: absolute ;
    right: 20px ;
    bottom: 0px ;
    font-size: 15px;
}

.Home_Welfare_view::after {
    content: "";
    position: absolute;
    width: 80px;
    height: 10px;
    bottom: -1px;
    right: -10px;
    border-bottom: 1px solid #6b4000;
    border-right: 0.1px solid #6b4000;
    transform: scale(0, 1);
    transform-origin: left top;
    transition: transform .3s;
}



.Home_Welfare_li_icon {
    color: #fff;
    float: right;
}

// Application
.Home_Application {
    color: #c04d00;
    font-size: 16px;
}

.Home_Application_text {
    font-size: 16px;
}

.Home_circle {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    background: #c04d00;
    border-radius: 50%;
    width: 120px;
    height: 120px;
    color: #efefef;
    font-size: 12px;
    padding-right: 5px;
    position: relative;
    z-index: 0;
    overflow: hidden;
    
}
.Home_circle::before {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 0%;
    background-color: #6b4000;
    -webkit-transition: .2s;
    transition: .2s;
}

.Home_circle_view {
    color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    font-size: 15px;
}
.Home_circle_view::after {
    content: "";
    position: absolute;
    width: 58px;
    height: 7px;
    bottom: -1px;
    right: 3px;
    border-bottom: 1px solid #fff;
    border-right: 0.1px solid #fff;
    transform: scale(0, 1);
    transform-origin: left top;
    transition: transform .3s;
}

.theme--light.v-divider {
    border-color: #c04d00 !important; 
}

.vue-cursor-fx { 
   position: fixed  !important;
}
.container {
  max-width: 1200px  !important;
}
.v-application a {
  text-decoration: none;
  cursor: none;
}
#fixed {
  position: fixed;
  top: 80%;
  left: 50%;
  transform: translateX(-50%);
}
</style>